import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

//import Accordion from 'react-bootstrap/Accordion';
import { PublicAccordion } from 'Components/Public/Accordion/PublicAccordion';
import { ICONS } from 'Utils/icons';
//import { Stack } from 'react-bootstrap';
import { IconTextButton, TextButton } from 'Components/Button';
import { NumberedSteps, NumberedStepsSplit } from 'Components/Public/NumberedSteps/NumberedSteps';
//import { ArrowRight, Favorite, PlayCircle, ThumbDown, ThumbDownAltOutlined, ThumbUp } from '@mui/icons-material';
//import reCAPTCHA from 'Images/recaptchaimg.png';
//import ahrqlogo from 'Images/ahrqlogo.png';
import AIImage from 'Images/public/learnfromdata/AiImage.png';
import FilterImg from 'Images/public/learnfromdata/FilterImage.png';
import CompareImage from 'Images/public/learnfromdata/ComparativeImage.png';
import DashboardInnovationsImg from 'Images/public/learnfromdata/DashboardInnovations.png';
import AhrqLogo from 'Images/public/learnfromdata/ahrqlogo.png';
//import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { PageHeader } from 'Components/Public/PageHeader/PageHeader';
//import { FloatingCallToAction } from 'Components/Public/FloatingCallToAction/FloatingCallToAction';
import { DidFindPrompt } from 'Components/Public/DidFindPrompt/DidFindPrompt';
import { NextPage } from 'Components/Public/NextPage/NextPage';
//import { Navigate } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';
import { getDocInfo, handleFileDownload, isLoggedIn, openInNewTab } from 'Utils/utilityFunctions';
//import checkIcon from 'Images/shieldcheck.png';
//import datasetIcon from 'Images/Dataset.png';
//import postIcon from 'Images/postplus.png';
//import connectIcon from 'Images/connect.png';
import DownloadLink from 'Components/Public/DownloadLink/DownloadLink';
import { useEffect, useState } from 'react';
import ArticleCard from 'Components/Public/ArticleCards/ArticleCard';
import logoIcon from 'Images/public/header/PSOPPC-logo.png';
import ArticleCardLink from 'Components/Public/ArticleCards/ArticleCardLink';
import ReportingImg from 'Images/public/learnfromdata/DataReportingImg.png';
import Feedback from "../../../Components/Public/Feedback/Feedback";
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";

//DOWNLOAD
function LearnFromTheData () {
  
    const navigate = useNavigate();
    const [doc145, setDoc145] = useState(null);
    const [doc2856, setDoc2856] = useState(null);
    const [doc2062, setDoc2062] = useState(null);

    return (
        <>
          <ReCaptchaWrapper
            action="learn_from_data_landing"
            title="Learn from the Data"
          >
            <Row className="m-0 p-0">
                <PageHeader
                    title="Learn from the Data"
                    intro="The Network of Patient Safety Databases (NPSD) team at AHRQ transforms your submitted, non-identifiable patient safety data into useful tools like dashboards and reports with clear, actionable information. Your PSO can use these resources to develop strategies that improve patient safety and healthcare outcomes."
                >
                </PageHeader>
                <Row lg={1} className="m-0 mb-5 mt-5 pt-4 pb-4 d-flex justify-content-center g-0">
                    <Col xs={11} sm={9} md={11} lg={10} xl={9} className="d-flex flex-column gap-80px">
                        <Col lg={12} className="article-cards  no-min g-0 gap-0 gap-4 w-100 d-flex flex-nowrap flex-lg-nowrap flex-column flex-lg-row  justify-content-lg-between">
                            <Col lg={8} className="article-card-col ">
                                <ArticleCard
                                    imgHeight="352"
                                    imgVariant="auto"
                                    classes="w-100"
                                    bg="article-gray"
                                    groupId={2471}
                                    image={DashboardInnovationsImg}
                                    imageAlt={"Bar chart illustrating the distribution of healthcare events."}
                                    text={"Gain deeper insights through updates like trend tracking, demographic drill-downs, and clearer comparisions."}
                                    isVideo={false}
                                    action={() => handleFileDownload(2471)}
                                ></ArticleCard>
                            </Col>
                            <Col className="d-flex flex-column wavy-bg-small justify-content-center align-items-center">
                                <h2 className="header2 bold color-193F64 mb-4">Subscribe to NPSD Publications</h2>
                                <p className="body semilight ">Sign up to be alerted about the latest publications from the NPSD</p>
                                <IconTextButton variant="normal" icon={ICONS.launch} content="Subscribe" onClick={() => { openInNewTab('https://subscriptions.ahrq.gov/accounts/USAHRQ/subscriber/new?topic_id=USAHRQ_38') }} className="reverse w-xs-100 w-sm-fit-content d-flex  justify-content-center mt-4"></IconTextButton>

                            </Col>
                        </Col>
                        <Col lg={12} className="article-cards  no-min g-0 gap-0 gap-4 w-100 d-flex flex-wrap flex-xl-nowrap flex-column flex-lg-row  justify-content-lg-between">
                            <Row xl={4} lg={2} xs={1} className="gy-4">
                                <Col className="article-card-col">
                                    <ArticleCard
                                        imgVariant="top"
                                        classes="w-100"
                                        bg="article-gray"
                                        groupId={2372}
                                        image={AIImage}
                                        imageAlt={"Flow chart comparing CFER-H V1.2 and CFER-H V2.0 event reporting."}
                                        text={"Identifying AI-related errors and informing future safety strategies as AI becomes more prevalent in healthcare."}
                                        isVideo={false}
                                        action={() => handleFileDownload(2372)}
                                    ></ArticleCard>
                                </Col>
                                <Col className="article-card-col">
                                    <ArticleCard
                                        imgHeight="120"
                                        imgVariant="top"
                                        classes="w-100"
                                        bg="article-gray"
                                        groupId={2371}
                                        image={logoIcon}
                                        imageAlt={""}
                                        text={"Exploring AI's role, benefits, and risks in improving patient safety."}
                                        isVideo={false}
                                        action={() => handleFileDownload(2371)}
                                    ></ArticleCard>
                                </Col>
                                <Col className="article-card-col">
                                    <ArticleCard
                                        imgVariant="top"
                                        classes="w-100"
                                        bg="article-gray"
                                        groupId={1762}
                                        image={FilterImg}
                                        imageAlt={"Multi-line chart displaying the frequency of reported Blood Product types from 2010 to 2019."}
                                        text={"Filter your submitted data by time, demographics, and more and visualize the results in interactive dashboards."}
                                        isVideo={false}
                                        action={() => handleFileDownload(1762)}
                                    ></ArticleCard>
                                </Col>
                                <Col className="article-card-col">
                                    <ArticleCard
                                      imgVariant="top"
                                      classes="w-100"
                                      bg="article-gray"
                                      groupId={`2328`}
                                      image={ReportingImg}
                                      imageAlt={"Line chart showing the number of reports by CFER-H version from 2014 to 2023."}
                                      text={"Recent data submissions show faster reporting with V2.0 and Medication/Substance and Falls as the most common event types."}
                                      isVideo={false}
                                      action={() => handleFileDownload(2471)}
                                    ></ArticleCard>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12} className="d-none article-cards horiz no-min g-0 gap-0 gap-4 w-100 d-lg-flex flex-wrap flex-lg-nowrap flex-column  justify-content-lg-between">
                            <Col className="article-card-col">
                                <ArticleCard
                                    imgHeight="120"
                                    imgVariant="horiz"
                                    classes="w-100"
                                    bg="article-gray"
                                    groupId={135}
                                    image={logoIcon}
                                    imageAlt={""}
                                    text={"Filter your submitted data by time, demographics, and more and visualize the results in interactive dashboards."}
                                    isVideo={false}
                                    action={() => handleFileDownload(135)}
                                ></ArticleCard>
                            </Col>
                            {/*<Col className="article-card-col">*/}
                            {/*    <ArticleCard*/}
                            {/*        imgVariant="horiz"*/}
                            {/*        classes="w-100"*/}
                            {/*        bg="article-gray"*/}
                            {/*        groupId={2328}*/}
                            {/*        image={ReportingImg}*/}
                            {/*        imageAlt={"Line chart showing the number of reports by CFER-H version from 2014 to 2023."}*/}
                            {/*        text={"Recent data submissions show faster reporting with V2.0 and Medication/Substance and Falls as the most common event types."}*/}
                            {/*        isVideo={false}*/}
                            {/*        action={() => handleFileDownload(2328)}*/}
                            {/*    ></ArticleCard>*/}
                            {/*</Col>*/}

                            <Col className="article-card-col">
                                <ArticleCard
                                    imgHeight="120"
                                    imgVariant="horiz"
                                    classes="w-100"
                                    bg="article-gray"
                                    groupId={2244}
                                    image={logoIcon}
                                    imageAlt={""}
                                    text={"Tools to address workplace safety, falls, and behavioral health."}
                                    isVideo={false}
                                    action={() => handleFileDownload(2244)}
                                ></ArticleCard>
                            </Col>

                        </Col>
                        <Col lg={12} className="g-0 network-publications-col">
                            <h2 className="bold displayM color-193F64 text-start">Network of Patient Safety Databases (NPSD) Publications</h2>
                            <Col lg={12} className="article-cards  no-min g-0 gap-0 gap-4  d-flex flex-wrap flex-lg-nowrap flex-column flex-lg-row  justify-content-lg-between">
                                <Col lg={8} className="article-cards horiz no-min g-0 gap-0 gap-4 d-flex flex-wrap flex-lg-nowrap flex-column  justify-content-lg-between">
                                    <Col className="article-card-col">
                                        <ArticleCardLink
                                            isExternal={true}
                                            cardTitle="NPSD Chartbooks"
                                            imgVariant="horiz"
                                            classes="w-100 ahrq-card"
                                            bg="article-gray"

                                            image={AhrqLogo}
                                            imageAlt={""}
                                            text={"Including the 2026 Generic Chartbook"}
                                            isVideo={false}
                                            action={() => openInNewTab("https://www.ahrq.gov/npsd/data/chartbook/index.html")}
                                        ></ArticleCardLink>
                                    </Col>
                                    <Col className="article-card-col">
                                        <ArticleCardLink
                                            isExternal={true}
                                            cardTitle="NPSD Dashboards with Data through 2025"
                                            imgVariant="horiz"
                                            classes="w-100 ahrq-card"
                                            bg="article-gray"

                                            image={AhrqLogo}
                                            imageAlt={""}
                                            text={"Including redesigned Generic and Falls Dashboards"}
                                            isVideo={false}
                                            action={() => openInNewTab("https://www.ahrq.gov/npsd/data/dashboard/index.html")}
                                        ></ArticleCardLink>
                                    </Col>
                                    <Col className="article-card-col">
                                        <ArticleCardLink
                                            isExternal={true}
                                            cardTitle="Data Spotlights"
                                            imgVariant="horiz"
                                            classes="w-100 ahrq-card"
                                            bg="article-gray"

                                            image={AhrqLogo}
                                            imageAlt={""}
                                            text={"Coming soon: “AI Free-Text Analysis of OTHER Event Type”"}
                                            isVideo={false}
                                            action={() => openInNewTab("https://www.ahrq.gov/npsd/data/spotlights.html")}
                                        ></ArticleCardLink>
                                    </Col>
                                </Col>
                                <Col className="d-flex flex-column wavy-bg-small justify-content-center align-items-center h-xs-fit-content">
                                    <h2 className="header2 bold color-193F64 mb-4">Submit data to contribute</h2>
                                    <p className="body semilight ">Your data is crucial for informing the findings in the upcoming reports. Submit your data now to see it in action.</p>
                                    <TextButton variant="normal" content="Submit Data" onClick={() => { navigate(PATHS.public['Submit Data']) }} className="reverse w-xs-100 w-sm-fit-content d-flex  justify-content-center mt-4"></TextButton>
                                </Col>
                            </Col>
                        </Col>
                    </Col>
                </Row>
            </Row>
            <Row className="faq m-0 d-flex justify-content-center">
                <Col lg="10">
                    <h2 className="mb-5">Frequently Asked Questions</h2>
                    <PublicAccordion
                        defaultActiveKey={[]}
                        accordionItemsContent={[
                            {
                                header: "Will the data I submit be shared with CMS or any other government entities?",
                                content: () => {
                                    return (
                                        <>
                                            <p>
                                                No, data submitted to the PSOPPC on behalf of your PSO is not shared with CMS or any other government agencies; instead, the PSOPPC de-identifies the data and securely transmits it to the NPSD to support national patient safety learning and improvement.
                                            </p>
                                        </>
                                    )
                                }
                            },
                            {
                                header: "Will the data I submit be used to benchmark my PSO against other submitters?",
                                content: () => {
                                    return (
                                        <>
                                            <p className="mb-0">
                                                No, the PSOPPC does not develop benchmark rates or benchmark prevalence and your data is not used for benchmarking. As a PSO that submits patient safety event data, you can login to the secure pages of the PSOPPC website to view your PSO’s data in interactive dashboards and compare your event volume trends and incident rate trends to national aggregates via the Comparative National Dashboard (CND).
                                            </p>
                                        </>
                                    )
                                }
                            },
                            {
                                header: "What safeguards prevent re-identification of my PSO or members in trends published by the NPSD?",
                                content: () => {
                                    return (
                                        <>
                                            <p className="mb-0">
                                                The PSOPPC applies rigorous de-identification protocols before transmission to the NPSD, including:
                                            </p>
                                            <ul className='accordion-list-style'>
                                                <li>
                                                    Removal of patient DOB, neonate DOB, and age (replaced with age category)
                                                </li>
                                                <li>
                                                    Conversion of event/report dates to year and quarter
                                                </li>
                                                <li>
                                                    Exclusion of PSO IDs and pseudo provider IDs
                                                </li>
                                                <li>
                                                    Suppression of specific data elements (e.g., Record Id, Submission Date, Type of NQF serious reportable event, etc.)
                                                </li>
                                                <li>
                                                    Omission of identifying information in free-form text fields
                                                </li>
                                            </ul>
                                            <p>
                                                All Patient Safety Work Product (PSWP) is handled securely and in compliance with HIPAA.
                                                The NPSD infrastructure and data suppression rules ensure that re-identification of PSOs,
                                                providers, or patients is not possible.
                                            </p>
                                        </>
                                    )
                                }
                            },
                            {
                                header: "How much data does the PSOPPC receive and how often?",
                                content: () => {
                                    return (
                                        <>
                                            <p>
                                                Submission volume and frequency vary by PSO. By 2025, the NPSD contains approximately 4 million patient safety event reports, with submissions occurring weekly, monthly, quarterly, or annually, depending on each PSO’s reporting structure.
                                            </p>
                                            <p>
                                                While some PSOs contribute larger volumes of data, the PSOPPC employs robust, federally mandated safeguards to ensure that no PSO—regardless of submission size—can be re-identified. These protections apply consistently across all submissions and are designed to maintain strict confidentiality and data integrity within the national system.
                                            </p>
                                        </>
                                    )
                                }
                            },
                            {
                                header: "Are the data points used in the PSOPPC Tableau interface the same ones used in the NPSD Chartbooks?",
                                content: () => {
                                    return (
                                        <>
                                            <p>
                                                The Tableau interface for PSOs and the public-facing NPSD Chartbooks both utilize PSO-submitted data, but they serve different purposes and are presented differently:
                                            </p>
                                            <p>
                                                1. PSOPPC Tableau Dashboards:
                                            </p>
                                            <ul className='accordion-list-style'>
                                                <li>
                                                    These include the Clinical Dashboard and the Comparative National Dashboard.
                                                </li>
                                                <li>
                                                    They display data distributions specific to the submitting PSO and comparisons to other PSOs in aggregate.
                                                </li>
                                                <li>
                                                    Designed for internal PSO use.
                                                </li>
                                            </ul>
                                            <p>
                                                2. NPSD Chartbooks and Dashboards:
                                            </p>
                                            <ul className='accordion-list-style'>
                                                <li>
                                                    Intended for a broader, public audience.
                                                </li>
                                                <li>
                                                    Data is aggregated across all PSOs.
                                                </li>
                                                <li>
                                                    Certain sensitive data is omitted or further aggregated (e.g., residual harm, rare age groups) to reduce the risk of identifying individual cases, in compliance with non-identification requirements.
                                                </li>
                                            </ul>
                                        </>
                                    )
                                }
                            },
                            {
                                header: "When the PSOPPC performs AI-based free-text analysis, how are identifiers removed?",
                                content: () => {
                                    return (
                                        <>
                                            <p>
                                                Our number one priority is protecting the identities of patients, providers, and reporters. When submitting data to PSOPPC, we ask that PSOs assign unique Provider IDs to their member providers so information can’t be tracked back to an individual or facility. Also, prior to analysis, all submitted free-text data undergoes a de-identification process to eliminate personally identifiable information (PII), including the replacement of names, addresses, and dates with standardized placeholders (e.g., “NAME,” “ADDRESS,” “DATE”).
                                            </p>
                                            <p>
                                                This process ensures that the data used for AI free-text analysis remains fully anonymized and adheres to strict privacy and confidentiality standards.
                                            </p>
                                        </>
                                    )
                                }
                            },
                        ]}
                    ></PublicAccordion>
                </Col>
            </Row>
          </ReCaptchaWrapper>
          <DidFindPrompt></DidFindPrompt>

          <Feedback/>
          

          <NextPage path={PATHS.public['Data Security']} text="Data Security"
              backPath={PATHS.public['Submit Data']} backPathText="Submit Data"
          ></NextPage>
        </>
    );
}

export default LearnFromTheData;
